import { authenticate, authenticateThirdPartySupplier } from '../../api'
import history from '../../history'
import jwtDecode from 'jwt-decode'

function login (accessToken, onSuccessRedirectPath, onErrorRedirectPath) {
  return dispatch => {
    dispatch(request())

    authenticate(accessToken).fetchPromise
      .then(
        response => {
          try {
            const decoded = jwtDecode(response.token)
            dispatch(success({ user: decoded.email, userId: decoded.userId, accessToken: response.token }))
            history.push(onSuccessRedirectPath)
          } catch (e) {
            dispatch(failure('Error'))
            history.push(onErrorRedirectPath)
          }
        },
        error => {
          dispatch(failure(error.message))
          history.push(onErrorRedirectPath)
        }
      )
  }

  function request () { return { type: 'USER_LOGIN_REQUEST' } }

  function success (payload) { return { type: 'USER_LOGIN_SUCCESS', payload } }

  function failure (error) { return { type: 'USER_LOGIN_FAILURE', payload: { error } } }
}

function loginSupplier (supplierId, code, email) {
  return dispatch => {
    dispatch(request())

    authenticateThirdPartySupplier(supplierId, code, email).fetchPromise
      .then(
        async (response) => {
          try {
            if (response.status === 404) {
              history.push('/errors/property-not-found')
              return
            }
            if (response.status === 403) {
              history.push('/errors/not-authorized')
              return
            }
            if (!response.ok) {
              throw new Error('request failed with status: ' + response.status + ', ' + response.json)
            }
            const body = await response.json()
            const decoded = jwtDecode(body.jwt)
            dispatch(success({ user: decoded.email, accessToken: body.jwt }))
            history.push('/property/' + body.giataId)
          } catch (e) {
            console.error(e)
            dispatch(failure('Error'))
            history.push('/errors/unknown')
          }
        },
        error => {
          console.error(error)
          dispatch(failure(error.message))
          history.push('/errors/unknown')
        }
      )
  }

  function request () { return { type: 'USER_LOGIN_REQUEST' } }

  function success (payload) { return { type: 'USER_LOGIN_SUCCESS', payload } }

  function failure (error) { return { type: 'USER_LOGIN_FAILURE', payload: { error } } }
}

const logout = () => ({
  type: 'USER_LOGOUT'
})

const setToken = (accessToken) => ({
  type: 'USER_SET_TOKEN',
  payload: {
    accessToken
  }
})

export const userActions = {
  login,
  logout,
  setToken,
  loginSupplier
}
